import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { error } from 'console';
import { AgendaService } from 'src/app/service/agenda.service';
import { Globals } from 'src/app/service/global';
import { SettingsService } from 'src/app/service/settings-service';
import { SideNavServiceService } from 'src/app/service/side-nav-service.service';

@Component({
  selector: 'app-settings-page',
  templateUrl: './settings-page.component.html',
  styleUrls: ['./settings-page.component.css']
})
export class SettingsPageComponent implements OnInit {

  emailSettingsValues = new UntypedFormGroup({
    DAILY_ACTIVITY_SEND: new UntypedFormControl(),
    MEETING_REM_DURATION: new UntypedFormControl(),
    APPROVE_DURATION: new UntypedFormControl(),
    GUEST_INVITE_SCH: new UntypedFormControl(),
    NOTIFY_GUEST_MAIL: new UntypedFormControl(),
  });

  notesSettingsValues = new UntypedFormGroup({
    AGENDA_NOTES_COUNT: new UntypedFormControl(),
    MOMEDIT: new UntypedFormControl(),
    SHOWTZ_AI: new UntypedFormControl(),
  });

  dashboardSettings = new UntypedFormGroup({
    UPCOMING_MEETING_CONF: new UntypedFormControl(),
    UPCOMING_TASK_CONF: new UntypedFormControl(),
    PAST_MEETING_CONF: new UntypedFormControl(),
    UPCOMING_START_CONF: new UntypedFormControl(),
    UPCOMING_MEETING_WAIT_CONF: new UntypedFormControl(),
    COMPLETED_TASK_CONF: new UntypedFormControl(),
    DELETE_MEET_CONF: new UntypedFormControl(),
  });

  otherSettingValues = new UntypedFormGroup({
    ALL_NOTIFIC_COUNT: new UntypedFormControl(),
    ALERT_NOTIFIC_COUNT: new UntypedFormControl(),
    TIMER_EXTEND_DURATION: new UntypedFormControl(),
    WAIT_TO_CREATE_MOM: new UntypedFormControl(),
  });

  outlookCal = new UntypedFormGroup({
    APP_ID_CONF : new UntypedFormControl(),
    CLIENT_SECRET_CONF : new UntypedFormControl(),
    DIRECTORY_ID_CONF: new UntypedFormControl()
  });

  zoomIntegration = new UntypedFormGroup({
    ZOOM_USERID : new UntypedFormControl(),
    ZOOM_SDK_SECRET_KEY : new UntypedFormControl(),
    ZOOM_SDK_SECRET_ID: new UntypedFormControl(),
    ZOOM_JWT_API_KEY: new UntypedFormControl(),
    ZOOM_JWT_SECRET_ID:new UntypedFormControl(),

  });

  settingValues: any;
  dailyActSend!: boolean;
  notifyGuestMail!: boolean;
  guestInSch!: boolean;
  showTz!: boolean;
  momEdit!: boolean;
  maintenanceSettingval: any = [];
  guestInviteSchConVal!: string;
  notifyGuestMailConVal!: string;
  dailyActivityConVal!: string;
  momEditConVal!: string;
  showZ_AIConVal!: string;
  settingsValues!: [];
  userId:any;


  constructor(private agedna : AgendaService, private globals: Globals,private sideNav : SideNavServiceService,private settings:SettingsService) {
    this.userId=localStorage.getItem("userId");
    this.setData();
  }

  ngOnInit(): void {
  }
     
  

  setData() {
    
      this.emailSettingsValues.controls['DAILY_ACTIVITY_SEND'].setValue(this.globals.settingValuesList.DAILY_ACTIVITY_SEND);
      if(this.emailSettingsValues.controls['DAILY_ACTIVITY_SEND'].value == 'Y'){
        this.emailSettingsValues.controls['DAILY_ACTIVITY_SEND'].setValue(true);
      }else{
        this.emailSettingsValues.controls['DAILY_ACTIVITY_SEND'].setValue(false);
      }      

      this.emailSettingsValues.controls['MEETING_REM_DURATION'].setValue(this.globals.settingValuesList.MEETING_REM_DURATION);
      this.emailSettingsValues.controls['APPROVE_DURATION'].setValue(this.globals.settingValuesList.APPROVE_DURATION);
      this.emailSettingsValues.controls['GUEST_INVITE_SCH'].setValue(this.globals.settingValuesList.GUEST_INVITE_SCH);

      if(this.emailSettingsValues.controls['GUEST_INVITE_SCH'].value == 'Y'){
        this.emailSettingsValues.controls['GUEST_INVITE_SCH'].setValue(true);
      }else{
        this.emailSettingsValues.controls['GUEST_INVITE_SCH'].setValue(false);
      }
      this.emailSettingsValues.controls['NOTIFY_GUEST_MAIL'].setValue(this.globals.settingValuesList.NOTIFY_GUEST_MAIL);

      if(this.emailSettingsValues.controls['NOTIFY_GUEST_MAIL'].value == 'Y'){
        this.emailSettingsValues.controls['NOTIFY_GUEST_MAIL'].setValue(true);
      }else{
        this.emailSettingsValues.controls['NOTIFY_GUEST_MAIL'].setValue(false);
      }

      this.notesSettingsValues.controls['MOMEDIT'].setValue(this.globals.settingValuesList.MOMEDIT);
      if(this.notesSettingsValues.controls['MOMEDIT'].value == 'Y'){
        this.notesSettingsValues.controls['MOMEDIT'].setValue(true);
      }else{
        this.notesSettingsValues.controls['MOMEDIT'].setValue(false);
      }

      this.notesSettingsValues.controls['SHOWTZ_AI'].setValue(this.globals.settingValuesList.SHOWTZ_AI);
      if(this.notesSettingsValues.controls['SHOWTZ_AI'].value == 'Y'){
        this.notesSettingsValues.controls['SHOWTZ_AI'].setValue(true);
      }else{
        this.notesSettingsValues.controls['SHOWTZ_AI'].setValue(false);
      }

      this.dashboardSettings.controls['UPCOMING_MEETING_CONF'].setValue(this.globals.settingValuesList.UPCOMING_MEETING_CONF);
      this.dashboardSettings.controls['PAST_MEETING_CONF'].setValue(this.globals.settingValuesList.PAST_MEETING_CONF);
      this.dashboardSettings.controls['UPCOMING_TASK_CONF'].setValue(this.globals.settingValuesList.UPCOMING_TASK_CONF);
      this.dashboardSettings.controls['UPCOMING_MEETING_WAIT_CONF'].setValue(this.globals.settingValuesList.UPCOMING_MEETING_WAIT_CONF);
      this.dashboardSettings.controls['UPCOMING_START_CONF'].setValue(this.globals.settingValuesList.UPCOMING_START_CONF);
      this.dashboardSettings.controls['DELETE_MEET_CONF'].setValue(this.globals.settingValuesList.DELETE_MEET_CONF); 
      
      this.otherSettingValues.controls['ALL_NOTIFIC_COUNT'].setValue(this.globals.settingValuesList.ALL_NOTIFIC_COUNT);
      this.otherSettingValues.controls['TIMER_EXTEND_DURATION'].setValue(this.globals.settingValuesList.TIMER_EXTEND_DURATION);
      this.otherSettingValues.controls['WAIT_TO_CREATE_MOM'].setValue(this.globals.settingValuesList.WAIT_TO_CREATE_MOM);
      this.outlookCal.controls['APP_ID_CONF'].setValue(this.globals.settingValuesList.APP_ID_CONF);
      this.outlookCal.controls['CLIENT_SECRET_CONF'].setValue(this.globals.settingValuesList.CLIENT_SECRET_CONF);
      this.outlookCal.controls['DIRECTORY_ID_CONF'].setValue(this.globals.settingValuesList.DIRECTORY_ID_CONF);

      //this.zoomIntegration.controls['ZOOM_USERID'].setValue(this.globals.settingValuesList.ZOOM_USERID);
      //this.zoomIntegration.controls['ZOOM_SDK_SECRET_KEY'].setValue(this.globals.settingValuesList.ZOOM_SDK_SECRET_KEY);
      //this.zoomIntegration.controls['ZOOM_SDK_SECRET_ID'].setValue(this.globals.settingValuesList.ZOOM_SDK_SECRET_ID);
      //this.zoomIntegration.controls['ZOOM_JWT_API_KEY'].setValue(this.globals.settingValuesList.ZOOM_JWT_API_KEY);
      //this.zoomIntegration.controls['ZOOM_JWT_SECRET_ID'].setValue(this.globals.settingValuesList.ZOOM_JWT_SECRET_ID);

    }

  saveEmailSettings() {
    
  var element = <HTMLInputElement> document.getElementById("dailyActivitySend-input");
  var newElement = <HTMLInputElement> document.getElementById("notifyGuestUser-input");
  var newElement2 = <HTMLInputElement> document.getElementById("guestUserInviteSch-input");
  var activitysend = element.checked;
  var notifyGUser = newElement.checked;
  var guestInvite = newElement2.checked;      
  
  if(activitysend == false){
    this.dailyActivityConVal = 'N';
  }else{
    this.dailyActivityConVal = 'Y'
  }

  if(notifyGUser == false){
    this.notifyGuestMailConVal = 'N'
  }else{
    this.notifyGuestMailConVal = 'Y'
  }

  if(guestInvite == false){
    this.guestInviteSchConVal = 'N'
  }else{
    this.guestInviteSchConVal = 'Y'
  }
  
    var emailSettingJson =
    {
      "_id": 0,
      "controlCodeJson": [
        {
          "parentCode": "EMAIL_SETTINGS",
          "controlCode": "APPROVE_DURATION",
          "controlValue": this.emailSettingsValues.controls['APPROVE_DURATION'].value
        },
        {
          "parentCode": "EMAIL_SETTINGS",
          "controlCode": "MEETING_REM_DURATION",
          "controlValue": this.emailSettingsValues.controls['MEETING_REM_DURATION'].value
        },
        {
          "parentCode": "EMAIL_SETTINGS",
          "controlCode": "DAILY_ACTIVITY_SEND",
          "controlValue": this.dailyActivityConVal
        },
        {
          "parentCode": "EMAIL_SETTINGS",
          "controlCode": "NOTIFY_GUEST_MAIL",
          "controlValue": this.notifyGuestMailConVal
        },
        {
          "parentCode": "EMAIL_SETTINGS",
          "controlCode": "GUEST_INVITE_SCH",
          "controlValue": this.guestInviteSchConVal
        }
      ],
      "orgCode": this.globals.orgCode
    }

    this.settings.saveSettingsInfo(emailSettingJson).subscribe((data: any) => {
      this.settings.fetchSettingsListSource('Y');

    });
    this.sideNav.alertSaveSettings("saveSettings");
    
  }

  saveNoteSettings() {

    var elementOne = <HTMLInputElement> document.getElementById("momEdit-input");
    var elementTwo = <HTMLInputElement> document.getElementById("showTz-input");
    
    var momEd = elementOne.checked;
    var showTimezone = elementTwo.checked;

    if(momEd == false){
      this.momEditConVal = 'N';
    }else{
      this.momEditConVal = 'Y';
    }

    if(showTimezone == false){
      this.showZ_AIConVal = 'N'
    }else{
      this.showZ_AIConVal = 'Y'
    }


    var notesSettingJson =
    {
      "_id": 0,
      "controlCodeJson": [
        {
          "parentCode": "NOTES_SETTINGS",
          "controlCode": "MOMEDIT",
          "controlValue": this.momEditConVal
        },
        {
          "parentCode": "NOTES_SETTINGS",
          "controlCode": "SHOWTZ_AI",
          "controlValue": this.showZ_AIConVal
        }
      ],
      "orgCode": this.globals.orgCode
    }

    this.settings.saveSettingsInfo(notesSettingJson).subscribe((data: any) => {
      this.settings.fetchSettingsListSource('Y');
    });
    this.sideNav.alertSaveSettings("saveSettings");
    
  }

  saveDashboardSettings(){

    var dashboardSettingJson =
    {
      "_id": 0,
      "controlCodeJson": [
        {
          "parentCode": "DASHBOARD_SETTINGS",
          "controlCode": "UPCOMING_MEETING_CONF",
          "controlValue": this.dashboardSettings.controls['UPCOMING_MEETING_CONF'].value
        },
        {
          "parentCode": "DASHBOARD_SETTINGS",
          "controlCode": "UPCOMING_TASK_CONF",
          "controlValue": this.dashboardSettings.controls['UPCOMING_TASK_CONF'].value
        },
        {
          "parentCode": "DASHBOARD_SETTINGS",
          "controlCode": "PAST_MEETING_CONF",
          "controlValue": this.dashboardSettings.controls['PAST_MEETING_CONF'].value
        },
        {
          "parentCode": "DASHBOARD_SETTINGS",
          "controlCode": "UPCOMING_START_CONF",
          "controlValue": this.dashboardSettings.controls['UPCOMING_START_CONF'].value
        },
        {
          "parentCode": "DASHBOARD_SETTINGS",
          "controlCode": "UPCOMING_MEETING_WAIT_CONF",
          "controlValue": this.dashboardSettings.controls['UPCOMING_MEETING_WAIT_CONF'].value
        },
        {
          "parentCode": "DASHBOARD_SETTINGS",
          "controlCode": "DELETE_MEET_CONF",
          "controlValue": this.dashboardSettings.controls['DELETE_MEET_CONF'].value
        }
      ],
      "orgCode": this.globals.orgCode
    }
    this.settings.saveSettingsInfo(dashboardSettingJson).subscribe((data: any) => {
      this.settings.fetchSettingsListSource('Y');
    });
    this.sideNav.alertSaveSettings("saveSettings");
    
  }

  saveOtherSettings(){

    var otherSettingJson =
    {
      "_id": 0,
      "controlCodeJson": [
        {
          "parentCode": "OTHER_SETTINGS",
          "controlCode": "ALL_NOTIFIC_COUNT",
          "controlValue": this.otherSettingValues.controls['ALL_NOTIFIC_COUNT'].value
        },
        {
          "parentCode": "OTHER_SETTINGS",
          "controlCode": "TIMER_EXTEND_DURATION",
          "controlValue": this.otherSettingValues.controls['TIMER_EXTEND_DURATION'].value
        },
        {
          "parentCode": "OTHER_SETTINGS",
          "controlCode": "WAIT_TO_CREATE_MOM",
          "controlValue": this.otherSettingValues.controls['WAIT_TO_CREATE_MOM'].value
        }
      ],
      "orgCode": this.globals.orgCode
    }

    this.settings.saveSettingsInfo(otherSettingJson).subscribe((data: any) => {
      this.settings.fetchSettingsListSource('Y');
    });
    this.sideNav.alertSaveSettings("saveSettings");
    
  }

outlookCalSave(){
  var otherSettingJson =
  {
    "_id": 0,
    "controlCodeJson": [
      {
        "parentCode": "OUTLOOK_CAL_SETTINGS",
        "controlCode": "APP_ID_CONF",
        "controlValue": this.outlookCal.controls['APP_ID_CONF'].value
      },
      {
        "parentCode": "OUTLOOK_CAL_SETTINGS",
        "controlCode": "CLIENT_SECRET_CONF",
        "controlValue": this.outlookCal.controls['CLIENT_SECRET_CONF'].value
      },
      {
        "parentCode": "OUTLOOK_CAL_SETTINGS",
        "controlCode": "DIRECTORY_ID_CONF",
        "controlValue": this.outlookCal.controls['DIRECTORY_ID_CONF'].value
      }
    ],
    "orgCode": this.globals.orgCode
  }

  this.settings.saveSettingsInfo(otherSettingJson).subscribe((data: any) => {
    this.settings.fetchSettingsListSource('Y');
  });
  this.sideNav.alertSaveSettings("saveSettings");
}

zoomConfigSave(){

  var otherSettingJson =
  {
    "_id": 0,
    "controlCodeJson": [
      {
        "parentCode": "ZOOM_MEETING_SETTINGS",
        "controlCode": "ZOOM_USERID",
        "controlValue": this.zoomIntegration.controls['ZOOM_USERID'].value
      },
      {
        "parentCode": "ZOOM_MEETING_SETTINGS",
        "controlCode": "ZOOM_SDK_SECRET_KEY",
        "controlValue": this.zoomIntegration.controls['ZOOM_SDK_SECRET_KEY'].value
      },
      {
        "parentCode": "ZOOM_MEETING_SETTINGS",
        "controlCode": "ZOOM_SDK_SECRET_ID",
        "controlValue": this.zoomIntegration.controls['ZOOM_SDK_SECRET_ID'].value
      },
      {
        "parentCode": "ZOOM_MEETING_SETTINGS",
        "controlCode": "ZOOM_JWT_API_KEY",
        "controlValue": this.zoomIntegration.controls['ZOOM_JWT_API_KEY'].value
      },
      {
        "parentCode": "ZOOM_MEETING_SETTINGS",
        "controlCode": "ZOOM_JWT_SECRET_ID",
        "controlValue": this.zoomIntegration.controls['ZOOM_JWT_SECRET_ID'].value
      }

    ],
    "orgCode": this.globals.orgCode
  }

  this.settings.saveSettingsInfo(otherSettingJson).subscribe((data: any) => {
    this.settings.fetchSettingsListSource('Y');
  });
  this.sideNav.alertSaveSettings("saveSettings");
}

  resetDefaultVal(){
    this.setData();

  }

  numberOnly(event:any) {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;

  }

  preMeetId:any
  curMeetId:any
  
  followup(){
    var json={
      meetingId:this.curMeetId,
      userId: this.userId
    }

    this.agedna.reviewPAstAgenda(this.preMeetId,json).subscribe((data)=>{
 
    },error=>{
 
    })

  }

}
